module.exports = __webpack_public_path__ + "static/media/bridge-title.2f997dbd.png";